export type MealPlanItemMeal = {
  id: string;
  name: string;
  image: string;
  imageThumbnail: string | null;
};

export type MealPlanItem = {
  id: string;
  meal: MealPlanItemMeal;
};

export type MealPlanStatus = 'active' | 'completed';

type MealPlan = {
  id: string;
  name: string;
  dueDate: Date | null;
  status: MealPlanStatus;
  createdAt: Date;
  items: MealPlanItem[];
};

export const mapMealPlanFromApi = (plan: any): MealPlan => ({
  id: plan.id,
  name: plan.name,
  dueDate: plan.dueDate ? new Date(plan.dueDate * 1000) : null,
  status: plan.status,
  createdAt: new Date(plan.createdAt * 1000),
  items: (plan.items ?? []).map((item: any) => ({
    id: item.id,
    meal: {
      id: item.meal.id,
      name: item.meal.name,
      image: item.meal.image,
      imageThumbnail: item.meal.imageThumbnail ?? null,
    },
  })),
});

export default MealPlan;
